const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/components/Alert/MetaKatAlertList.tsx';
import React from 'react';
import { css } from '@emotion/css';
import { Alert } from './Alert';
import { useMessages } from 'App/store/messages';
import { MetaKatTranslation } from '../MetaKatLocalizedText/MetaKatTranslation';

type AlertListPros = {};

const alertListCss = css`
    width: 100%;
`;

export const MetaKatAlertList = (props: AlertListPros) => {
    const { data: messages } = useMessages();

    if (!messages?.length) return null;

    return (
        <div className={alertListCss}>
            {messages.map((message, i) => {
                return (
                    <Alert key={message.ICODE} color={message.status}>
                        <MetaKatTranslation translations={message.translations} />
                    </Alert>
                );
            })}
        </div>
    );
};
